module.exports = __webpack_public_path__ + "static/media/wizard-logo.dc7719e7.png";